import { FrameSlot, type Frame } from "./FrameSlot";

/**
 * The end frame (#228): the image the video ends on, with the start frame's menu. Live shows it
 * only for a model that takes one; the composer leaves it out otherwise.
 */
export function EndFrameSlot({ end }: { end: Frame }) {
  return <FrameSlot label="End frame" frame={end} />;
}
